import React from "react";
import PropTypes from "prop-types";

const AtomIcon2 = ({ icon, className, size }) => {
  return (
    <span 
      className={`un-icon-${icon} inline-flex items-center justify-center ${className}`} 
      style={{ fontSize: size }}
    >      
    </span>
  );
};

AtomIcon2.propTypes = {
  icon: PropTypes.string.isRequired,
  className: PropTypes.string, // Pour ajouter des styles CSS
  size: PropTypes.string, // Taille en `px`, `rem` etc.
};

AtomIcon2.defaultProps = {
  className: "",
  size: "30px",
};

export default AtomIcon2;
